import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { LoadingSpinner } from "@/pages/Rounds";
import type { RankingRewardSlice } from "@/types/RankingRewardSlice";
import { RankingRewardsTable } from "./RankingRewardsTable";

interface RankingRewardsModalProps {
  isViewRankingRewards: boolean;
  setIsViewRankingRewards: (value: boolean) => void;
  rankingRewardSlices: RankingRewardSlice[];
  isLoading: boolean;
}

const Header = ({ title }: { title: string }) => (
  <div className="bg-orange h-[71px] overflow-hidden rounded-tl-lg rounded-tr-lg flex items-center justify-center relative">
    <img className="w-[89px] h-[64px] top-[7px] left-[13px] absolute" src="/assets/YOSOMI.png" alt="YOSOMI" />
    <div className="text-white text-center text-[24px] font-bold leading-[35px]">{title}</div>
    <img
      src="/assets/_編集モード.png"
      className="h-[62.397px] w-[76.947px] right-[13.05px] top-[3.84px] absolute"
      alt="_編集モード"
    />
  </div>
);

const CloseButton = ({ onClick }: { onClick: () => void }) => (
  <div className="mb-[21px] mt-[14px] mx-[30px] flex justify-center items-center ">
    <Button className="text-base underline" variant="link" onClick={onClick}>
      閉じる
    </Button>
  </div>
);

export const RankingRewardsModal = ({
  isViewRankingRewards,
  setIsViewRankingRewards,
  rankingRewardSlices,
  isLoading,
}: RankingRewardsModalProps) => {
  if (isLoading) {
    return (
      <Dialog open={isViewRankingRewards} onOpenChange={setIsViewRankingRewards}>
        <DialogContent className="w-[380px] p-0 ring-0 ring-transparent">
          <div className="flex flex-col items-center justify-center h-[542px]">
            <LoadingSpinner />
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={isViewRankingRewards} onOpenChange={setIsViewRankingRewards}>
      <DialogContent className="[&>button]:hidden min-w-[380px] w-auto p-0 ring-0 ring-transparent">
        <div className="flex flex-col">
          <Header title="報酬情報" />
          <RankingRewardsTable rankingRewardSlices={rankingRewardSlices} />
          <CloseButton onClick={() => setIsViewRankingRewards(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
